// A maple in autumn colours: a reddish-brown trunk under a broad canopy of warm
// orange / russet leaf blobs. Ported 1:1 from age-of-mcp's classic tree-maple.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.075, 0.12, 0.7, 5),
      color: "#6b4326", position: [0, 0.35, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.5, 0),
      color: "#c8631f", position: [0, 1.06, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.4, 0),
      color: "#d98a2b", position: [-0.34, 0.92, 0.16] },
    { geometry: new THREE.IcosahedronGeometry(0.34, 0),
      color: "#b14618", position: [0.34, 1.2, -0.12] },
    { geometry: new THREE.IcosahedronGeometry(0.26, 0),
      color: "#e8a73e", position: [0.06, 1.46, 0.18] },
  ];
}

export const treeMaple = defineModel({
  id: "tree-maple",
  batchId: "standard",
  name: "Tree maple",
  tags: ["scenery","tree","maple","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tree maple.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.58,
  parts: () => partsFor(),
  animations: [],
});
